<template>
    <div>
        <h1 class="display-heading">Partner Payouts (Outstanding)</h1>

        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col width="150">
                        <col width="220">
                        <col width="220">
                        <!-- <col width="180"> -->
                        <col width="150">
                        <col width="200">
                        <col>
                        <col width="80">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th class="text-right">No. of Txn(s)</th>
                            <th>Oldest Unsettled <br>Txn Date</th>
                            <th>Latest Unsettled <br>Txn Date</th>
                            <th class="text-right">Disburseable <br>Amount (RM)</th>
                            <!-- <th>Disbursement Date</th> -->
                            <th>Partner Type</th>
                            <th>Partner Name</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(payout, index) in payoutList" :key="index">
                            <td>{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</td>
                            <td class="text-right">
                                {{payout.count}}
                            </td>
                            <td class="text-nowrap">
                                {{payout.firstTxnDate}}
                            </td>
                            <td class="text-nowrap">
                                {{payout.lastTxnDate}}
                            </td>

                            <td class="text-right">
                                {{ payout.total }}
                            </td>
                            <td>{{ payout.roleName}}</td>
                            <td>
                                {{ payout.partnerName }}
                            </td>
                            <td>
                                <router-link :to="{'name': 'admin-partner-payout-detail-v2', 'params': {'role': payout.role, 'roleId': payout.roleId }}">
                                    View
                                </router-link>
                            </td>
                        </tr>
                        <tr v-show="payoutList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage" :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import { convertToUserReadableDate } from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'PartnerPayoutV2',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage (val) {
            if (!this.isTableLoading) {
                this.$nextTick(() => {
                    this.getPayouts();
                });
            }
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'payoutList': []
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window
                .scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPayouts();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getPayouts () {
            this.payoutList = [];
            this.isTableLoading = true;
            this.axios.post('PaymentList/GetPayoutRecordsV2', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.payoutList = list.map((txn) => ({
                    'role': txn.p ? txn.p.pr : null,
                    'roleName': txn.p ? txn.p.rn : '-',
                    'roleId': txn.p ? txn.p.pi : null,
                    'partnerName': txn.p ? txn.p.n : '-',
                    'firstTxnDate': txn.ft ? convertToUserReadableDate(txn.ft) : '-',
                    'lastTxnDate': txn.lt ? convertToUserReadableDate(txn.lt) : '-',
                    'count': txn.tc,
                    'total': txn.tt.toFixed(2)
                }));
            });
        }
    }
};
</script>
